<!--
 * @Description: 订单提示->交易结构冲突
 * @Date: 2020-12-12 16:02:25
-->
<template>
  <table-render ref="tableRender" :config="config" height="35vh">
    <template slot="batchAction">
      <el-row type="flex" justify="flex-start">
        <span class="error alert">
          如有疑问，请联系向日葵平台服务人员协助解决。
        </span>
      </el-row>
    </template>
  </table-render>
</template>

<script>
import tableRender from '@/components/tableRender';
import { conflict } from './config';
import { deepClone } from '@/tools';

export default {
  name: 'OrderConflict',
  props: {
    // 接口入参
    query: {
      type: Object,
      default() {
        return {
          ids: '' // userId_taxCollectionPattern 用户ID_交易结构，逗号分隔
        };
      }
    },
    // 获取列表接口
    getListAjax: {
      type: Function,
      default() {
        return () => {};
      }
    }
  },
  data() {
    return {
      config: null
    };
  },
  components: { tableRender },
  watch: {},
  methods: {},
  created() {
    const d = deepClone(conflict);
    // 列表接口携带固定参数
    d[0].childMenu[0].defaultQuery = this.query;
    d[0].childMenu[0].list = this.getListAjax;
    this.config = d;
  }
};
</script>
